import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=c8ec2dc2"
import script from "./DeleteDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteDialog.vue?vue&type=style&index=0&id=c8ec2dc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports